import { gql } from '@apollo/client';

export const fetchCampaignLabelsQuery = gql`
  query getCampaignLabels {
    campaignLabels {
      id
      name
    }
  }
`;

export const fetchListsQuery = gql`
  query getLists(
    $filterInfo: ListFilterInfoInput
    $pagination: Pagination
    $search: String
    $sort: Sort
  ) {
    lists(filterInfo: $filterInfo, pagination: $pagination, sort: $sort, search: $search) {
      results {
        id
        name
      }
    }
  }
`;

export const fetchListQuery = gql`
  query getList($id: Long!) {
    list(id: $id) {
      name
      id
    }
  }
`;

export const fetchMessageTypesQuery = gql`
  query getMessageTypes {
    messageTypes {
      id
      name
    }
  }
`;

export const fetchMessageChannelsQuery = gql`
  query getMessageChannels {
    messageChannels {
      id
      name
    }
  }
`;
